// eslint-disable-next-line no-shadow
enum Gender {
  MALE = 'M',
  FEMALE = 'F',
  OTHERS = 'O',
}
export default Gender;
